import React from 'react'
import Layout from '../components/Layout'
import Hero from '../components/Hero'
import { graphql } from 'gatsby'
import Projects from '../components/Projects'
import Banner from '../components/Banner'

const ProjectsPage = ({ data }) => {
  const {
    allMdx: { nodes: projects },
  } = data
  const type = 'gatsby'
  return (
    <section>
      <Hero />
      <Banner />
      <Projects projects={projects} />
    </section>
  )
}

export const query = graphql`
  {
    allMdx(sort: { fields: frontmatter___date, order: DESC }) {
      nodes {
        excerpt
        frontmatter {
          slug
          date(formatString: "MMM Do, YYYY")
          author
          category
          difficulty
          excerpt
          readTime
          image {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        id
      }
    }
  }
`

export default ProjectsPage
